import consumer from '../consumer';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import { bus } from 'shared/helpers/bus';

consumer.subscriptions.create('CallsChannel', {
  connected() {},
  disconnected() {},
  received(data) {
    bus.$emit(BUS_EVENTS.CALL_RECEIVED, data);
  },
});
